import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as env from 'config/environment';
import * as consts from 'config/consts';
import { formatDate } from 'utils/formatter';
import Loading from 'components/commons/loading/Loading';
import Footer from 'components/commons/Footer';
import Pagination, { PageParamType } from 'components/features/Pagination';
import { isApp } from 'components/features/utils/userStatus';
import LoginSideMenu from './components/LoginSideMenu';
import { HeadBlock } from './components/HeadBlock';
import { BreadcrumbList } from './PostNotificationListDetail';
import { NotificationItems } from './Login';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

const PostNotificationList: React.FC = () => {
  const [isShowSideMenu, setIsShowSideMenu] = useState(false);
  const [hideAnimate, setHideAnimate] = useState<boolean>(false);

  const menuShow = (): void => {
    setIsShowSideMenu(true);
    setHideAnimate(false);
  };
  const menuHide = (): void => {
    setIsShowSideMenu(false);
  };
  const menuHideAnimate = (): void => {
    setHideAnimate(true);
  };

  const getURLWithParameter = (url: string): string => {
    return `${url}?service=${env.serviceName}&callback_url=${encodeURI(
      `${env.appURL}/auth`
    )}`;
  };
  const login = (): void => {
    window.location.href = getURLWithParameter(env.loginURL);
  };
  const register = (): void => {
    window.location.href = getURLWithParameter(env.registerURL);
  };

  const headers = {
    Accept: 'application/json',
  };

  //------------------------------------------------------------
  // お知らせ一覧（スタイル・高さの自動計算）
  //------------------------------------------------------------
  const getNotificationItemsStyle = () => {
    const sh = window.innerHeight;
    const hh = document.getElementById('id_header')?.offsetHeight;
    const fh = document.getElementById('id_footer')?.offsetHeight;
    const lh = document.getElementById('id_lineBanner')?.offsetHeight;
    const vhh = document.getElementById('id_notificationViewHeader')
      ?.offsetHeight;
    const vmh = document.getElementById('id_notificationViewMenu')
      ?.offsetHeight;
    const vph = document.getElementById('id_notificationViewPagination')
      ?.offsetHeight;

    if (!sh || !hh || !fh || !lh || !vhh || !vmh || !vph) return {};
    return { height: sh - (hh + fh + lh + vhh + vmh + vph) + 'px' };
  };

  //------------------------------------------------------------
  // ページ変更
  //------------------------------------------------------------
  const onChangePage = (newPageParam: PageParamType): void => {
    setSelectPage(newPageParam.selectPage);
  };

  //------------------------------------------------------------
  // 指定ページの該当データを抽出
  //------------------------------------------------------------
  const paginationFilter = (
    items: NotificationItems[],
    selectPage: number
  ): NotificationItems[] => {
    const max = items.length;
    return items.filter((_, index) => {
      const nSelectPage = Number(selectPage);
      let stIndex: number = (nSelectPage - 1) * maxRecordsPerPage;
      let edIndex: number = nSelectPage * maxRecordsPerPage - 1;

      if (stIndex > max) stIndex = max;
      if (edIndex > max) edIndex = max;

      return stIndex <= index && edIndex >= index;
    });
  };

  const startPage = 1;
  const initialSelectPage = 1;

  // お知らせ一覧の１ページあたりの最大表示件数
  const maxRecordsPerPage = 10;

  // 選択しているtypeのお知らせ情報全量
  const [notifications, setNotifications] = useState<
    NotificationItems[] | null
  >(null);
  // 表示対象のお知らせ
  const [notificationItems, setNotificationItems] = useState<
    NotificationItems[]
  >([]);

  // 表示ページ
  const [selectPage, setSelectPage] = useState<number>(initialSelectPage);
  // 総ページ数
  const [totalPageCount, setTotalPageCount] = useState<number | undefined>(
    undefined
  );

  const getBorderClass = (index: number, length: number) => {
    return index === 0
      ? 'border-t border-l border-r'
      : index === length - 1
      ? 'border rounded-b'
      : 'border-t border-l border-r';
  };

  useEffect(() => {
    document.domain === 'localhost'
      ? (async () => {
          const res = await fetch(
            `https://stg.tw.minkabu.jp/status/notifications.json`,
            {
              cache: 'no-cache',
              method: 'GET',
              headers,
            }
          );
          if (res.status === 200) {
            const data_ = (await res.json()) as NotificationItems[];
            const data = data_.filter(
              data => data.BeforeLogin === consts.NotificationCode.投稿
            );
            setNotifications(data);
            setTotalPageCount(Math.ceil(data.length / maxRecordsPerPage));
          }
        })()
      : (async () => {
          const res = await fetch(`${env.appURL}/status/notifications.json`, {
            cache: 'no-cache',
            method: 'GET',
            headers,
          });
          if (res.status === 200) {
            const data_ = (await res.json()) as NotificationItems[];
            const data = data_.filter(
              data => data.BeforeLogin === consts.NotificationCode.投稿
            );
            setNotifications(data);
            setTotalPageCount(Math.ceil(data.length / maxRecordsPerPage));
          }
        })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ページ変更
  useEffect(() => {
    if (notifications === null) return;
    // 対象ページの情報を絞り込む
    const newItems = paginationFilter(notifications, Number(selectPage));
    setNotificationItems(newItems);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications, selectPage]);

  const history = useHistory();
  const gotoLpNotificationListDetail = useCallback(
    (notificationID: string): void => {
      history.push(`/postNotificationList/${notificationID}`);
    },
    [history]
  );

  useEffect(() => {
    //toggle(表示・非表示の切り替え)
    //.js_toggle_switchのデータ属性(data-toggle="クラス名")と同じクラス名の要素の表示非表示の切り替えを行う
    //
    //sample
    //<button class="js_toggle_switch" data-toggle="js_rnavi">ボタン</button>
    //<div class="js_rnavi">表示切り替えエリア</div>
    //
    //クラス名がかぶらないよう、操作するクラスにつけるクラス名はルール化する
    //クラス名ルール例："js_"+"表示する内容を詳しく"
    $(function() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      $('.js_toggle_switch').click(function(event: any) {
        const js_disp_area = '.' + $(event.currentTarget).data('toggle');
        $(js_disp_area).toggleClass('is-visible');
      });
    });

    //モーダルに画像入れる
    //const modalWrapper = document.querySelector('.ui-modal');
    const images = document.querySelectorAll('.image');
    const modalImage = document.querySelector('.modal-image');

    images.forEach(function(image) {
      image.addEventListener('click', function() {
        //modalWrapper.classList.add('show');
        //modalImage.classList.add('show');

        const imageSrc = image.getAttribute('data-src');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (modalImage as any).src = imageSrc;
      });
    });

    //modalWrapper.addEventListener('click', function() {
    //     if (this.classList.contains('show')) {
    //          this.classList.remove('show');
    //         modalImage.classList.remove('show');
    //     }
    //});

    //scroll
    const Ease = {
      easeInOut: (t: number) =>
        t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    };
    const duration = 500;
    const smoothScrollTriggers = document.querySelectorAll('a[href^="#"]');
    smoothScrollTriggers.forEach(function(smoothScrollTrigger) {
      smoothScrollTrigger.addEventListener('click', function(e: Event) {
        const href = smoothScrollTrigger.getAttribute('href');
        const currentPostion =
          document.documentElement.scrollTop || document.body.scrollTop;
        const targetElement = document.getElementById(
          (href as string).replace('#', '')
        );
        if (targetElement) {
          e.preventDefault();
          e.stopPropagation();
          const targetPosition =
            window.pageYOffset +
            targetElement.getBoundingClientRect().top -
            115;
          const startTime = performance.now();
          const loop = function(nowTime: number) {
            const time = nowTime - startTime;
            const normalizedTime = time / duration;
            if (normalizedTime < 1) {
              window.scrollTo(
                0,
                currentPostion +
                  (targetPosition - currentPostion) *
                    Ease.easeInOut(normalizedTime)
              );
              requestAnimationFrame(loop);
            } else {
              window.scrollTo(0, targetPosition);
            }
          };
          requestAnimationFrame(loop);
        }
      });
    });

    //スクロールして画面内に入ってきたらfadeinアニメーションクラスを付与
    const myFunc = function() {
      //Classを追加する要素を取得
      const target = document.getElementsByClassName('js-ui-animation-fadeup');
      //Classを追加する位置を指定（ビューポート内）
      const position = Math.floor(window.innerHeight * 0.85); //左記はビューポート内の上から85%の位置を指定

      //要素の数だけループする
      for (let i = 0; i < target.length; i++) {
        //要素の上部座標を取得する（小数点切り捨て）
        const offsetTop = Math.floor(target[i].getBoundingClientRect().top); //要素の上部座標がpositionの位置を通過したら
        if (offsetTop < position) {
          //要素にClassを追加する
          target[i].classList.add('ui-animation-fadeup');
        }
      }
    };
    //スクロールイベントリスナーに登録
    window.addEventListener('scroll', myFunc, false);

    return () => {
      window.removeEventListener('scroll', myFunc, false);
    };
  }, []);

  const isIE =
    (window.navigator.userAgent ?? '').toLowerCase().indexOf('trident') !== -1;

  const headBlockValue = {
    title: 'お知らせ一覧｜みんかぶアセットプランナー（アセプラ）',
    ogTitle: 'お知らせ一覧｜みんかぶアセットプランナー（アセプラ）',
    description:
      '投資分析、資産管理ならみんかぶアセットプランナー。株式、投資信託などの取引履歴を分析し配当金もまとめて管理。銀行口座や複数の証券口座の資産も一括管理できるアプリです。',
    ogDescription:
      '投資分析、資産管理ならみんかぶアセットプランナー。株式、投資信託などの取引履歴を分析し配当金もまとめて管理。銀行口座や複数の証券口座の資産も一括管理できるアプリです。',
    img: 'https://tw.minkabu.jp/static/images/lp/lp_og_image.png',
  };

  const breadcrumbInfo = [
    { name: 'アセプラTOP', path: '/' },
    { name: 'お知らせ一覧' },
  ];

  if (!notificationItems)
    return (
      <Loading
        loading={true}
        style={{
          backgroundColor: '#edf2f7',
          alignItems: 'normal',
          paddingTop: '200px',
          top: '95',
          left: '0',
        }}
      />
    );

  return (
    <>
      <HeadBlock
        {...{
          title: headBlockValue.title,
          ogTitle: headBlockValue.ogTitle,
          description: headBlockValue.description,
          ogDescription: headBlockValue.ogDescription,
          img: headBlockValue.img,
        }}
      />
      <div
        className={[
          'login flex flex-col h-full',
          isShowSideMenu && 'md_drawerright_open',
        ]
          .filter(x => x)
          .join(' ')}
        id="layout"
        style={{ backgroundColor: '#edf2f7' }}>
        <div className="flex-grow">
          <header
            className="bg-white z-50 shadow-md sticky top-0"
            id="id_header">
            <nav className="container space-x-2 items-center ui-header lg:flex hidden">
              <div className="text-gray-700 text-center ui-header-logo">
                <a title="みんかぶ" href="https://minkabu.jp/">
                  <img
                    src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
                    width="146"
                    height="40"
                    alt="みんかぶ"
                  />
                </a>
              </div>
              <div className="ui-header-menu">
                <ul className="flex justify-start pl-7 relative">
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://minkabu.jp/">
                      株式
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://us.minkabu.jp/">
                      米国株
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://fx.minkabu.jp/">
                      FX/為替
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://cc.minkabu.jp/">
                      仮想通貨
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://itf.minkabu.jp/">
                      投信
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://fu.minkabu.jp/">
                      先物
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://ins.minkabu.jp/">
                      保険
                    </a>
                  </li>
                  <li>
                    <a
                      className="text-bluegray-700 hover:opacity-75 hover:text-bluegray-700 hover:no-underline"
                      href="https://mag.minkabu.jp/">
                      初心者
                    </a>
                  </li>
                </ul>
              </div>
              <div className="ui-header-button-wrapper flex justify-end">
                <div className="ui-header-button flex space-x-2 lg:text-sm text-xs">
                  {isIE && (
                    <div className="text-sm text-gray-700">
                      Internet Explorerブラウザではご利用いただけません
                    </div>
                  )}
                  {!isIE && (
                    <>
                      <a
                        href={`${env.loginURL}?service=${
                          env.serviceName
                        }&callback_url=${encodeURI(`${env.appURL}/auth`)}`}
                        className="ui-button theme-normal w-1/2 login-exe"
                        id="click_login_header_login">
                        ログイン
                      </a>
                      <a
                        href={`${env.registerURL}?service=${
                          env.serviceName
                        }&callback_url=${encodeURI(`${env.appURL}/auth`)}`}
                        className="ui-button theme-sub w-1/2 register-exe"
                        id="click_login_header_register">
                        新規登録
                      </a>
                    </>
                  )}
                </div>
              </div>
            </nav>
            <div className="ui-header-sp border-b border-gray-300 block lg:hidden">
              <nav className="flex p-2">
                <div className="flex-1 flex justify-start">
                  <button className="flex items-center p-2 hidden">
                    <i className="icon-chevron-left text-2xl text-gray-700"></i>
                  </button>
                </div>
                <div className="flex-grow flex justify-center items-center">
                  <a title="みんかぶ" href="https://minkabu.jp/">
                    <img
                      src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
                      width="110"
                      height="30"
                      alt="みんかぶ"
                    />
                  </a>
                </div>
                <div className="flex-1 flex justify-end">
                  <section className="pl-4 pr-2 pt-2 ">
                    {!isApp && (
                      <div
                        className="btn-trigger "
                        id="btn01"
                        onClick={!isShowSideMenu ? menuShow : menuHideAnimate}>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    )}
                  </section>
                </div>
              </nav>
            </div>
            <div className="w-full lg:block hidden bg-gray-800">
              <nav className="relative  shadow top-0 border-t-0 text-white container m-auto">
                <ul className="table table-fixed font-bold w-full">
                  <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                    <a
                      style={{ lineHeight: '50px' }}
                      className="inline-block w-full"
                      href="https://minkabu.jp/pick/balance/buy"
                      title="株価予想">
                      株価予想
                    </a>
                  </li>
                  <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                    <a
                      style={{ lineHeight: '50px' }}
                      className="inline-block w-full"
                      href="https://minkabu.jp/financial_item_ranking"
                      title="株式ランキング">
                      株式ランキング
                    </a>
                  </li>
                  <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                    <a
                      style={{ lineHeight: '50px' }}
                      className="inline-block w-full"
                      href="https://minkabu.jp/news"
                      title="ニュース">
                      ニュース
                    </a>
                  </li>
                  <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                    <a
                      style={{ lineHeight: '50px' }}
                      className="inline-block w-full"
                      href="https://minkabu.jp/ir"
                      title="IRwith">
                      IRwith
                    </a>
                  </li>
                  <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25">
                    <a
                      style={{ lineHeight: '50px' }}
                      className="inline-block w-full"
                      href="https://minkabu.jp/beginner/"
                      title="株初心者入門">
                      株初心者入門
                    </a>
                  </li>
                  <li className="align-middle table-cell text-center hover:bg-white hover:bg-opacity-25 relative">
                    <a
                      style={{ lineHeight: '50px' }}
                      className="inline-block w-full"
                      href="https://tw.minkabu.jp/"
                      title="アセプラ（みんかぶアセットプランナー）へ">
                      アセプラで資産形成
                    </a>
                    <div className="h-1 bg-red-500 w-full absolute bottom-0"></div>
                  </li>
                </ul>
              </nav>
            </div>
          </header>

          {isShowSideMenu && (
            <LoginSideMenu
              hideAnimate={hideAnimate}
              menuHide={menuHide}
              onNavLinkClick={(e: React.MouseEvent, path: string) => {
                return;
              }}
            />
          )}
          <section className="container rounded-lg px-2 mb-16">
            <div className="mt-4 lg:mb-8 lg:max-w-864p lg:mx-auto">
              {BreadcrumbList(breadcrumbInfo)}
              <div className="w-full">
                <div className="text-center bg-white mt-3 text-gray-500 border-t border-l border-r border-gray-300 rounded-t">
                  <div className="w-1/4 py-2 text-xs ui-tab-menu-active">
                    サイトから
                  </div>
                </div>
              </div>

              <div
                id="id_notificationItemsView"
                className=""
                style={getNotificationItemsStyle()}>
                {notificationItems.length === 0 ? (
                  <></>
                ) : (
                  notificationItems.map((item, index, array) => {
                    const dispTime = item.UpdTime ?? item.InsTime;
                    return (
                      <div
                        className={`border-gray-300 border-solid p-2 ${getBorderClass(
                          index,
                          array.length
                        )} bg-white cursor-pointer`}
                        key={index}
                        onClick={() => gotoLpNotificationListDetail(item.ID)}>
                        <div className="flex text-sm m-1 px-8">
                          <div className="flex">
                            <div className="">
                              {formatDate(
                                new Date(dispTime),
                                'yyyy/MM/dd HH:mm'
                              )}
                            </div>
                            <div className="ml-4">お知らせ</div>
                          </div>
                        </div>
                        <div className="flex m-1 px-8">
                          <div className="w-full whitespace-pre-wrap break-all">
                            {item.Title}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              <div id="id_postNotificationList">
                <Pagination
                  startPage={Number(startPage)}
                  selectPage={Number(selectPage)}
                  totalPageCount={totalPageCount}
                  onChangePage={onChangePage}
                />
              </div>
            </div>
          </section>
        </div>

        <Footer showFooterMarginTop={false} />
      </div>
    </>
  );
};

export default PostNotificationList;
